// @ts-nocheck

/**
 * The Emarsys custom pixel events bridge.
 *
 * Flow: hook fetch + XHR -> match /cart/(add|change|update|clear)
 *       -> debounce 150ms -> GET {root}cart.js
 *       -> Shopify.analytics.publish('cart_updated', { cart }).
 */
(function () {

  if (window.__emarsysCartEventsInstalled) return;
  window.__emarsysCartEventsInstalled = true;

  const DEBUG = true; // GO-LIVE: set false.
  const DEBOUNCE_MS = 150;

  // Matches /cart/add, /cart/change, /cart/update, /cart/clear
  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(?:[/?#]|$)/i;

  const nativeFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
  let timer = null;
  let lastSignature = null;

  function log() {
    if (!DEBUG || !window.console || !console.log) return;
    try {
      console.log.apply(console, ['[emarsys-cart-events]'].concat([].slice.call(arguments)));
    } catch {
      console.log('console unavailable - ignore');
      /* console unavailable - ignore */
    }
  }

  function urlFromInput(input) {
    if (typeof input === 'string') return input;
    if (!input) return '';
    return input.url || input.href || '';
  }

  function isCartMutation(url) {
    return typeof url === 'string' && CART_MUTATION_RE.test(url);
  }

  function rootUrl() {
    const root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) ||
      (window.Theme && Theme.routes && Theme.routes.root) ||
      '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function scheduleUpdate() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(publishCartUpdate, DEBOUNCE_MS);
  }

  function cartSignature(cart) {
    const lines = (cart.items || [])
      .map(function (item) {
        return (item.key || item.id) + ':' + item.quantity + ':' + item.final_line_price;
      })
      .join(',');
    return cart.item_count + '|' + cart.total_price + '|' + lines;
  }

  function publishCartUpdate() {
    timer = null;

    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') {
      log('Shopify.analytics not ready - skipping publish');
      return;
    }
    if (!nativeFetch) return;

    nativeFetch(rootUrl() + 'cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) {
          log('cart.js returned an unexpected shape', cart);
          return;
        }
        const signature = cartSignature(cart);
        if (signature === lastSignature) {
          log('cart unchanged - skipping duplicate publish');
          return;
        }
        lastSignature = signature;
        Shopify.analytics.publish('cart_updated', { cart: cart });
        log('published cart_updated', cart.item_count, cart.currency);
      })
      .catch(function (error) {
        log('cart.js read failed', error);
      });
  }

  // --- fetch hook ---
  if (nativeFetch) {
    window.fetch = function (input, init) {
      const promise = nativeFetch(input, init);
      if (isCartMutation(urlFromInput(input))) {
        promise.then(
          function (response) {
            if (response && response.ok) scheduleUpdate();
          },
          function () {
            /* request failed - no cart change to report */
          },
        );
      }
      return promise;
    };
  }

  // --- XHR hook ---
  const XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    const nativeOpen = XHR.prototype.open;
    const nativeSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this.__emarsysCartMutation = isCartMutation(url);
      return nativeOpen.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      if (this.__emarsysCartMutation) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) scheduleUpdate();
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  document.addEventListener('cart:update', scheduleUpdate);

  log('installed');
})();
